import {
  Box,
  Center,
  Grid,
  Heading,
  HStack,
  Icon,
  Text,
  type ThemeColorPath,
  type ThemeColorTextPath,
  type ThemeIconKey,
  VStack,
} from 'platform/foundation';

import i18n from '@dms/i18n';

import {type MyDayData} from '../../../types/MyDayData';

interface MyDayMetricsProps {
  totals: NonNullable<MyDayData['totals']>;
}

export function MyDayMetrics(props: MyDayMetricsProps) {
  const metrics = [
    {
      label: i18n.t('page.interestMyDay.recommendations.title'),
      value: props.totals.recommended,
      icon: 'action/assignment_turned_in',
      background: 'palettes.blue.10.100',
      color: 'text.link',
      textColor: 'primary',
    },
    {
      label: i18n.t('aiAssistant.interest.signals.customerAwaitingReply.title'),
      value: props.totals.awaitingReply,
      icon: 'communication/email',
      background: 'palettes.red.10.100',
      color: 'text.danger',
      textColor: 'danger',
    },
    {
      label: i18n.t('page.interestMyDay.risks.title'),
      value: props.totals.atRisk,
      icon: 'alert/warning',
      background: 'palettes.orange.10.100',
      color: 'text.warning',
      textColor: 'warning',
    },
  ] satisfies {
    label: string;
    value: number;
    icon: ThemeIconKey;
    background: ThemeColorPath;
    color: ThemeColorPath;
    textColor: ThemeColorTextPath;
  }[];

  return (
    <Grid columns={[1, 3]} spacing={4}>
      {metrics.map((metric) => (
        <Box
          key={metric.label}
          backgroundColor="general.white"
          borderRadius="medium"
          boxShadow="elevation_1"
          padding={5}
        >
          <HStack spacing={4} align="center" justify="space-between">
            <VStack spacing={3}>
              <Text size="small" color="secondary">
                {metric.label}
              </Text>
              <Heading size={1} headingLevel={3} color={metric.textColor}>
                {metric.value.toString()}
              </Heading>
            </VStack>
            <Box backgroundColor={metric.background} borderRadius="medium" width={11} height={11}>
              <Center height="100%">
                <Icon value={metric.icon} size={5} color={metric.color} />
              </Center>
            </Box>
          </HStack>
        </Box>
      ))}
    </Grid>
  );
}
